import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana48Div1M2 = ({
  lands,
  landSelector = (_e, _id) => { },
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_29441)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        fill={getFillByLot(1, selected, lands)}
        d="M665.673 369.859L613.266 428.816L534.656 363.308L646.02 343.655C668.73 347.149 668.584 362.58 665.673 369.859Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        fill={getFillByLot(2, selected, lands)}
        d="M571.792 476.853L613.28 428.814L532.487 363.306L493.182 406.978L571.792 476.853Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        fill={getFillByLot(3, selected, lands)}
        d="M532.479 520.527L571.784 476.855L493.174 406.979L453.869 450.652L532.479 520.527Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        fill={getFillByLot(9, selected, lands)}
        d="M370.889 398.243L532.476 363.306L442.948 461.568L370.889 398.243Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        fill={getFillByLot(8, selected, lands)}
        d="M408.016 503.06L442.954 461.572L370.895 398.247L305.387 413.532L408.016 503.06Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        fill={getFillByLot(4, selected, lands)}
        d="M490.989 566.383L532.477 520.527L453.867 450.651L414.562 496.507L490.989 566.383Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        fill={getFillByLot(5, selected, lands)}
        d="M466.967 596.954L490.987 566.383L414.561 496.508L368.705 548.914C389.085 561.288 432.903 587.783 445.131 594.77C457.36 601.758 464.784 599.137 466.967 596.954Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        fill={getFillByLot(6, selected, lands)}
        d="M294.469 503.059L368.711 548.915L408.016 503.059L333.774 439.734L294.469 503.059Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        fill={getFillByLot(7, selected, lands)}
        d="M233.321 433.183L305.38 413.53L333.77 439.734L294.465 503.058L224.586 459.386C219.346 445.411 228.226 436.094 233.321 433.183Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_29441"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_29441"
            transform="matrix(0.00299518 0 0 0.00397081 -3.88641 -2.46811)"
          />
        </pattern>
        <image
          id="image0_1466_29441"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
